/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowBearRight = createReactComponent("arrow-bear-right", "IconArrowBearRight", [
  ["path", { d: "M12 3h5v5", key: "svg-0" }],
  [
    "path",
    { d: "M17 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93", key: "svg-1" }
  ]
]);

export { IconArrowBearRight as default };
//# sourceMappingURL=IconArrowBearRight.js.map
